import Base from 'models/Base';

export default class SearchResultItems extends Base {}
